/* This component will be used for the minibasket which opens up from the right in a sidebar/drawer */

import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useRouter } from "next/compat/router";
import Srcset from "@/components/common/Srcset";
import Link from "next/link";
import styles from "./Account.module.scss";
import FavouriteIcon from "../../common/FavouriteIcon";
import {
  bodyOverflow,
  checkUserLogin,
  forgotPassword,
  extractUserCauseFromTags,
} from "@/helpers/userHelpers";
import {
  saveUserCharityLocalStorage, updateUserCause, updateCartWhenCharityUpdates
} from "@/helpers/charityHelper";
import CreateAccount from "../../CreateAccount";
import SignUp from "../SignUp";
import { getCookie , deleteCookie, setCookie } from "cookies-next";
import { loggedInUser, openAccountSidebar, openAccountSidebarFromPwaHeader } from "@/redux/actions/loggedInUser";
import {
  setUserCause
} from "../../../redux/actions/generalAction";
import { errorMessages, generalConstants } from "@/utils/constants";
import MyAccountDashboard from "./MyAccountDashboard";
import { useIsPreviewing } from "@builder.io/react";
import { reportError } from "@/helpers/errorHelper";
import ActivateAccount from "./ActivateAccount";
import ActivateAccountTab from "./ActivateAccountTab";
import { removeArgumentsFromDocument } from "@apollo/client/utilities";
import { checkIfEmail } from "@/helpers/generalHelper";
import { openMiniCart, updateCart } from "@/redux/actions/addToCartAction";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";
import InputField from "@/components/common/CommonInputComponent";

export default function AccountComp(props) {
  const {
    setAccountSidebarOpen,
    accountSidebarOpen,
    DashboardCloseRef,
    drawer_section,
    drawer_tab,
    drawer_order_id,
    mobileAccountBar,
    myAccount,
    handleMobileAccountBar,
    disableForgotPass
  } = props
  const [email, setEmail] = useState("");
  const [submittedEmail, setSubmittedEmail] = useState("");
  const [migratedUserState, setMigratedUserState] = useState("");
  const router = useRouter();
  let [validEmail, setValidEmail] = useState();
  const [autoFillEmail, setAutoFillEmail] = useState();
  let [emailErrorMessage, setEmailErrorMessage] = useState();
  let [userLoginStatus, setUserLoginStatus] = useState(false);
  let [showForgotMessage, setShowForgotMessage] = useState(false);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  let logUser = useSelector((state) => state.loginUser);
  const [emailAtActivateAccount, setEmailAtActivateAccount] = useState(false)
  const dispatch = useDispatch();
  const logedIn = useSelector((state) => state.loginUser);
  const isUserLoggedIn = useSelector((state)=> state.loginUser?.userLoggedIn)
  const user_cause = useSelector((state) => state.general.user_cause);
  const default_cause = useSelector((state) => state.general.default_cause);
  const cause_list = useSelector((state) => state.general.cause_list);
  const open_signin_drawer= useSelector((state) => state.drawer.drawerSection);
  const openForgotSideBar = useSelector(
    (state) => state.loginUser.open_forgot_sidebar
  );
  const isPreviewing = useIsPreviewing();
  let [activateUrl, setactivateUrl] = useState(false);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const wc_journey_step = useSelector((state) => state.pwa.welcome_journey.currentStepNo);
  let showForgotPass = router.asPath.includes("checkoutURL");
  const validateAccessToken = async (token) => {
    let user_data = await checkUserLogin(token);

    if (user_data && user_data.userLoggedIn) {
      dispatch(loggedInUser(user_data));
      setUserName(user_data.userData.firstName);

      //This code get the user's cause from the tags and saves it in the local storage
      let causeInUrl = false;
      if(typeof window !== "undefined"){
        if(window.location.search.includes("cause")) {
          causeInUrl = true;
        }
      }
      if(user_data?.userData?.tags && !causeInUrl){
        let cause = await extractUserCauseFromTags(user_data.userData.tags)
        if(cause.length > 0){
          saveUserCharityLocalStorage(cause[0])
          dispatch(setUserCause(cause[0]))
        }
        else {
          // Update user cause in shopify when creating new account
          let causeToBeAdded = null;
          if(user_cause) causeToBeAdded = user_cause;
          else if(default_cause) causeToBeAdded = default_cause;
          try {
            causeToBeAdded = JSON.parse(causeToBeAdded);
          }
          catch(error) {
            reportError("Cause string format error");
            reportError(error);
          }
          if(causeToBeAdded) {
            if (cause_list) {
              const cause = cause_list.find(
                (cause) => cause.short_code === causeToBeAdded
              );
              if (cause) {
                const request = { cause: causeToBeAdded }
                console.log('updateUserCause header-account=====')
                updateUserCause(request);
                //Update cause realted custom attribute for cart line items
                updateCartWhenCharityUpdates(causeToBeAdded,cause_list);
                var updatedCartList = JSON.parse(sessionStorage.getItem("cart_list"));
                dispatch(updateCart(updatedCartList));
                dispatch(setUserCause(causeToBeAdded));
              }
            }
          }
        }
      }

    } else {
      dispatch(loggedInUser({}));
      setUserName("");
    }
    return user_data;
  };

  const ActivateUserByURL = async () => {
    if(!activateUrl){
      let token = router.query.url;
      if(token){
        setShowResetPassword("activateAccountTab")
      }
    }
  };

  useEffect(() => {
    if(router.query.url ){
      if(!logedIn.user_loggedIn){
        ActivateUserByURL();
      }
      else{
        router.push('/account');
      }
    }
    }, [router.query]);

    useEffect(() => {
      if(showForgotPass && openForgotSideBar ){
        setCookie("hide_signin_cross", false);
        setShowResetPassword("resetPassword");
      } else if (!openForgotSideBar) {
        setShowResetPassword(false);
      }
   
    }, [showForgotPass,openForgotSideBar]);

    

  let loginUser = useSelector((state) => state.loginUser.open_account_sidebar);

  //This state is set to know that the account drawer was opened through PWA header when the user was not logged in. It is set as true if the account drawer was open using PWA header when user was logged out
  let accountFromPwaHeader = useSelector((state) => state.loginUser.open_account_sidebar_pwa_header);

  useEffect(() => {

  if(loginUser === true){
    bodyOverflow();
    } else{
      bodyOverflow(false);
    }
  }, []);

  useEffect(() => {
    // if (typeof logedIn.user_loggedIn === "object") {
    //   setUserLoginStatus(true);
    // }

    if (getCookie("userdataToken")) {
      let cookie_data = JSON.parse(getCookie("userdataToken"));
      if(cookie_data != null){
        validateAccessToken(cookie_data.accessToken);
      }
    }

    if (logUser && logUser.userData && logUser.userData.firstName) {
      setUserName(logUser.userData.firstName);
    }
  }, []);
  useEffect(() => {
    const path = router.asPath
    if(path === "/account?activate_error") {
      setShowResetPassword("activateAccountTab")
    }
    if(path === "/account?activate_sucess") {
      alert("Account activated successfully")
    }
    //This code was added as part OS-976 but now it is going in infinite loop when user logs in using /login or /register
    // const handleRouteChange = (url, { shallow }) => {
    //   if (getCookie("userdataToken")) {
    //     let cookie_data = JSON.parse(getCookie("userdataToken"));
    //     validateAccessToken(cookie_data.accessToken);
    //   }
    //   if (logUser && logUser.userData && logUser.userData.firstName) {
    //     setUserName(logUser.userData.firstName);
    //   }
    // };
    // router.events.on("routeChangeStart", handleRouteChange);
    // return () => {
    //   router.events.off("routeChangeStart", handleRouteChange);
    // };
  }, []);
useEffect (()=>{
  if(logUser && logUser.userData) {
    setUserName(logUser.userData.firstName);
  }
  
},[logUser]);

  //Alert For Wrong Email format
  function handleEmailFormat(event) {
    let emailVal =
      event.target.email && event.target.email.value
        ? event.target.email.value
        : event.target.value;
    if (emailVal) {
      var validateEmail = checkIfEmail(emailVal);
      setValidEmail(validateEmail);
      if (!validateEmail) {
        // alert("Please enter a valid email address")
        setEmailErrorMessage(errorMessages.authentication.invalidEmail);
      } else {
        setEmailErrorMessage(null);
      }
      if (email) {
      } else {
        setEmailErrorMessage(null);
      }
    } else {
      setEmailErrorMessage(errorMessages.authentication.emptyEmail);
    }
  }
  //Check All fileds are filled or not
  function handleChange(event) {
    if (event.target.name == "email") {
      setEmail(event.target.value);
    }
  }

  const [signInTab, setSignInTab] = useState(true);

  useEffect(()=>{
    if(open_signin_drawer ==="register"){
      setSignInTab(false)
    } else if(open_signin_drawer ==="login"){
      setSignInTab(true)
    }
  },[open_signin_drawer])
  
  useEffect(() => {
    if (drawer_section === "register") {
      setSignInTab(false);
    }
    if (drawer_section === "activate-account") {
      setShowResetPassword("activateAccountTab");
      setEmailAtActivateAccount(true);
    }
  }, [drawer_section]);
  const [showResetPassword, setShowResetPassword] = useState(disableForgotPass);

  const activeElement = (val) => {
    setSignInTab(val);
  };
  // Handles the submit event on form submit.
  const handleSubmit = async (event) => {
    // Stop the form from submitting and refreshing the page.
    event.preventDefault();
    handleEmailFormat(event);
    if (email && validEmail) {
      // Get data from the form.
      const data = {
        email: event.target.email.value,
      };
      setLoading(true);
      const response = await forgotPassword(data);
      !response && alert(errorMessages.authentication.tryAgainLater);

      if (response && response.status === 200) {
        setShowForgotMessage(true);
      }
      setLoading(false);
    }
  };

  const signInBack = () => {
    setCookie("hide_signin_cross", false);
    if(getCookie('show_wishlist')) {
      dispatch(openAccountSidebar(false));
      dispatch(openWishlistSidebar(true));
      deleteCookie('show_wishlist')
    } else if (getCookie('redirect_path') == '/your-bag') {
      dispatch(openAccountSidebar(false));
      dispatch(openMiniCart(true));
      deleteCookie('redirect_path')
    } else if (getCookie('show_account_logout')) {
      dispatch(openAccountSidebarFromPwaHeader(true))
      dispatch(openAccountSidebar(true));
      deleteCookie('show_account_logout')
      //delete cookie which was added to re-open account sidebar for OS-4181
      if(getCookie('account_reopen')){
        deleteCookie('account_reopen')
      }
    } else {
      dispatch(openAccountSidebar(false));
      handleMobileAccountBar(false)
    }
  };

  // if  userLogged in
  if((isPWA && accountFromPwaHeader)||isUserLoggedIn||isPreviewing){
    return(
    <>
       <MyAccountDashboard
        mobileAccountBar={mobileAccountBar}
        accountSidebarOpen={logedIn?.open_account_sidebar}
        setAccountSidebarOpen={setAccountSidebarOpen}
        userName={userName}
        userDetails={logedIn?.userData}
        DashboardCloseRef={DashboardCloseRef}
        drawer_tab={drawer_tab}
        drawer_order_id={drawer_order_id}
        myAccount={myAccount}
        //editPageState={props.editPageState}
        //setEditPageState={props.setEditPageState}
        yotpoDetails={logedIn?.yotpoDetails}
      />
    </>
    )
  }
  
  // if the user not logged in then show the  SignIn or create Account Tab
  if (!isUserLoggedIn && !isPreviewing) {
    const accountTabDom = (
      <div className={`${styles.account_auth} ${isPWA && wc_journey_step!=6 && styles.pwa_login_wrapper}`}>
        <div
          className={`${styles.account_tab} ${
            signInTab ? `${styles.signin_tab_head}` : ""
          }`}
        >
          {isPWA && wc_journey_step == 6 && <a
          
          onClick={() => {
            signInBack();
          }}
        >
          <Srcset
            requirePath={true}
            svgFile={true}
            className={`back_icon ${styles.pwa_account_back}`}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="16"
            width="19.11"
            tabIndex={0}
          />
        </a>}
          <div className={`${styles.tab_head}`}>
            <div tabIndex={0}
              className={`xx-large-md xx-large-sm x-large-xs light ${styles.tab_item} ${
                signInTab ? `${styles.active}` : ""
              }`}
              onClick={() => {
                activeElement(true);
              }}
            >
              <span>Sign in</span>
            </div>
            <div  tabIndex={0}
              className={`xx-large-md xx-large-sm x-large-xs light ${styles.tab_item} ${
                signInTab ? "" : `${styles.active}`
              }`}
              onClick={() => {
                activeElement(false);
              }}
            >
              <span>Create account</span>
            </div>
          </div>
          {/* {logedIn.open_account_sidebar_withMsg!=""&&<div className={`${styles.signIn_msg_wrapper} bg-silk`}>
        <span className={`${styles.signIn_msg_wrapper_img}`}>
          <FavouriteIcon 
          height="12px"
          width="14px"
          />
        </span>
        <span className={` xx-small-xs x-small-sm small-md ${styles.signIn_msg_wrapper_msg}`}>
          {logedIn.open_account_sidebar_withMsg}
        </span>
      </div>} */}
          <div className={`${styles.tab_content}`}>
            {signInTab ? (
              <div className={`${styles.tab_content_item}`}>
                <SignUp
                  setEmailAtActivateAccount={setEmailAtActivateAccount}
                  setShowResetPassword={setShowResetPassword}
                  setAccountSidebarOpen={setAccountSidebarOpen}
                  autoFillEmail={autoFillEmail}
                  accountSidebarOpen={accountSidebarOpen}
                  drawer_section={drawer_section}
                  setSubmittedEmail={setSubmittedEmail}
                  setMigratedUserState={setMigratedUserState}
                />
              </div>
            ) : (
              <div className={`${styles.tab_content_item}`}>
                <CreateAccount
                  setShowResetPassword={setShowResetPassword}
                  setSignInTab={setSignInTab}
                  setAccountSidebarOpen={setAccountSidebarOpen}
                  setAutoFillEmail={setAutoFillEmail}
                  accountSidebarOpen={accountSidebarOpen}
                  drawer_section={drawer_section}
                  setSubmittedEmail={setSubmittedEmail}
                  setMigratedUserState={setMigratedUserState}
                  setEmailAtActivateAccount={setEmailAtActivateAccount}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
    let resetPasswordDom = (
      <div>
        <a
          onClick={() => {
            setShowResetPassword(false);
            setShowForgotMessage(false);
            setValidEmail(false);
            setEmailErrorMessage(false)
          }}
          className={!isPWA?"forgot_auth_back":"pwa_forgot_auth_back"}
        >
          <Srcset
            requirePath={true}
            svgFile={true}
            src="images/Icons/Arrow/Right/large.svg"
            alt="back-button"
            height="14.31"
            width="24"
            className="right_arrow"
            tabIndex={0}
          />
        </a>
        <Srcset
            onClick={() => {
              props.setAccountSidebarOpen(false);
              setShowResetPassword(false);
              setShowForgotMessage(false);
              setEmailErrorMessage(false)
            }}
            requirePath={true}
            svgFile={true}
            className={`${styles.forgot_password_close}`}
            src={"images/Icons/Cross/Large.svg"}
            alt="cloe button"
            height="16"
            width="19.11"
          />
        <div className={`${styles.account_auth} ${styles.forgot_auth}`}>
          <div className={`${styles.account_tab}`}>
            <div className={`${styles.tab_content}`}>
              <div className={`${styles.tab_content_item}`}>
                {showForgotMessage ? (
                  <>
                    <form
                      onSubmit={handleSubmit}
                      className={`${styles.form_wrap} ${styles.show_forgot_success}`}
                    >
                      <div className={`${styles.form_desc}`}>
                        <h4 className="large light">We&apos;ve received your password reset request</h4>
                        <p className="small-xs normal-sm normal-md">
                          Thanks for submitting your email address. We&apos;ve
                          sent you an email with the information needed to reset
                          your password.
                        </p>
                        <p className="small-xs normal-sm normal-md">
                          The email might take a couple of minutes to reach your
                          account.
                        </p>
                      </div>

                      <div className={`${styles.form_btn}`}>
                        <button
                          type="button"
                          className="normal btn-primary"
                          onClick={() => {
                            setShowResetPassword(false);
                            setShowForgotMessage(false);
                            setValidEmail(false);
                          }}
                        >
                          Log in
                        </button>
                      </div>
                      <div className={`${styles.form_assistance} ga-help`}>
                        <p className="small-xs normal-sm normal-md para-with-link">
                          Need assistance? Contact us by{" "}
                          <Link href={`mailto:${generalConstants.help_email}`} tabIndex={0}>
                              <span className="ga-help">email</span>
                          </Link>
                        </p>
                      </div>
                    </form>
                  </>
                ) : (
                  <>
                    <form
                      onSubmit={handleSubmit}
                      className={`${styles.form_wrap}`}
                    >
                      <div className={`${styles.form_desc}`}>
                        <h4 className="large light">Forgotten password?</h4>
                        <p className="small-xs normal-sm normal-md">
                          Enter the email address associated with your account,
                          and we’ll send you an email to reset your password.
                        </p>
                      </div>
                      <InputField
                        type="text"
                        id="email"
                        name="email"
                        label="Email*"
                        placeholder=" "
                        autoComplete="email"
                        ariaLabel="your-email"
                        className="normal-md small-xs normal-sm"
                        errorMessage={emailErrorMessage}
                        onFocus={e => e.currentTarget.placeholder = ``}
                        onChange={handleChange}
                        onBlur={(e) => {handleEmailFormat(e); 
                        }}
                        isEmail={true}
                      />

                      <div className={`${styles.form_btn}`}>
                        <button
                          type="submit"
                          className={`normal btn-primary ${styles.btn_loading} ${
                            loading ? "loading" : ""
                          }`}
                        >
                          <span>Submit</span>
                        </button>
                      </div>
                      <div className={`${styles.form_assistance}`}>
                        <p className="small-xs normal-sm normal-md para-with-link">
                          Need assistance? Contact us by{" "}
                          <Link href={`mailto:${generalConstants.help_email}`}>
                              <span className="ga-help">email</span>
                          </Link>
                        </p>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    
    switch (showResetPassword) {
      case "resetPassword": 
      return resetPasswordDom
      case "activateAccountTab":
        return <ActivateAccountTab emailAtActivateAccount={emailAtActivateAccount} showEmail={true} styles={styles} setShowResetPassword={setShowResetPassword} accountSidebarOpen={accountSidebarOpen} email={submittedEmail} migratedUserState={migratedUserState} setAutoFillEmail={setAutoFillEmail}/>
      case "activateAccount":
        return <ActivateAccount setSignInTab={setSignInTab} styles={styles} setShowResetPassword={setShowResetPassword} accountSidebarOpen={accountSidebarOpen} />
      default:
        return accountTabDom;
    }
  }
}
